import { toast } from 'react-toastify';
import axios from '../../axios';
import {
   GET_PURCHASE_ORDER,
   ADD_PURCHASE_ORDER,
   UPDATE_PURCHASE_ORDER,
   GET_PURCHASE_ORDER_BY_ID,
   DELETE_PURCHASE_ORDER,
   GET_LAST_PURCHASE_ORDER_DAYBOOK,
   DELETE_MULTI_PURCHASES_ORDER,
} from '../types';

export const addPurchaseOrder = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/purchase-order/add`, formData);
      if (res.data.code === 1) {
         dispatch({
            type: ADD_PURCHASE_ORDER,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         setTimeout(() => {
            toast.success('Purchase Order added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err?.response?.data?.message);
         return err?.response?.data;
      }
   }
};


export const getPurchaseOrder = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchase-order/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_ORDER,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
            },
         });
      }
   } catch (err) {
      console.error('getPurchaseInvoices err', err);
   }
};

// export const getPurchaseInvoicesForDaybook = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/purchase-invoice/all`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_PURCHASE_INVOICES_FOR_DAYBOOK,
//             payload: {
//                data: res.data.data,
//                pagination: res.data.pagination,
//             },
//          });
//       }
//    } catch (err) {
//       console.error('getPurchaseInvoices err', err);
//    }
// };

// export const getPurchaseInvoicestransactions = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/purchase-invoice/all`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_PURCHASE_INVOICES_TRANSACTIONS,
//             payload: {
//                data: res.data.data,
//                pagination: res.data.pagination,
//             },
//          });
//       }
//    } catch (err) {
//       console.error('getPurchaseInvoices err', err);
//    }
// };

// Get Single PurchaseInvoice
export const getPurchaseOrderById = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchase-order/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_ORDER_BY_ID,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
      }
   } catch (err) {
      console.error('getPurchaseInvoice err', err);
   }
};

// // Get Last Purchase Daybook
export const getLastPurchaseOrderDaybook = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      // const res = await axios.get(`/purchase/last`, { params });
      const res = await axios.get(`/purchase-order/lastDocNo`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_LAST_PURCHASE_ORDER_DAYBOOK, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      console.error('getLastPurchaseDaybook err', err);
   }
};

export const updatePurchaseOrder = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/purchase-order/update`, formData);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_PURCHASE_ORDER, payload: res.data.data });
         setTimeout(() => {
            toast.success('Purchase Order updated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
      return err.response?.data;
   }
};

// // Last Bill Purchase Invoice
// export const lastBillPurchaseInvoice = (params) => async (dispatch) => {
//    try {
//       const res = await axios.get(`/purchase/last-billNo`, {
//          params,
//       }); //pass Daybook ID
//       if (res.data.code === 1) {
//          dispatch({
//             type: LAST_BILL_PURCHASE_INVOICE,
//             payload: res.data.data,
//          });
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (err) {
//       if (err.response.data.message) {
//          toast.error(err.response.data.message);
//       }
//    }
// };
// Delete Purchase Invoice
export const deletePurchaseOrder = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.warn('Please select any record', 'warning');
         return false;
      }
      const res = await axios.post(`/purchase-order/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_PURCHASE_ORDER, payload: { id } });
         setTimeout(() => {
            toast.success('Purchase Order deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
   }
};

// export const deletePurchaseInvoice = (id, outAdjustmentIds = null) => async (dispatch) => {
//    try {
//       if (!id) {
//          toast.warn('Please select any record', 'warning');
//          return false;
//       }

//       let res;

//       // If outAdjustmentIds are provided, send them in the request body
//       if (outAdjustmentIds && outAdjustmentIds.length > 0) {
//          // Send outAdjustmentIds in request body
//          res = await axios.post(`/purchase-invoice/delete/${id}`, {
//             outAdjustmentIds: outAdjustmentIds,
//          });
//       } else {
//          // Normal deletion without body data
//          res = await axios.post(`/purchase-invoice/delete/${id}`);
//       }

//       if (res.data.code === 1) {
//          dispatch({ type: DELETE_PURCHASE_INVOICE, payload: { id } });
//          setTimeout(() => {
//             toast.success(res.data.message);
//          }, 1000);
//       }

//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (err) {
//       if (err?.response?.data?.message) {
//          toast.error(err?.response?.data?.message);
//       }
//    }
// };

// export const getSinglePurchaseInvoice = (id) => async (dispatch) => {
//    try {
//       const res = await axios.get(`/purchase-invoice/${id}`);
//       if (res.data.code === 1) {
//          dispatch({ type: GET_ONE_PURCHASE_INVOICE, payload: res.data.data });
//       }
//    } catch (err) {
//       console.error('Failed to get item by finish item. Please try again.');
//       if (err.response.data.message) {
//          toast.error(err.response.data.message);
//       }
//    }
// };

// export const getSingleWithPrevAndNext = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/purchase-invoice/all`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_PURCHASE_INVOICE_WITH_PREV_AND_NEXT,
//             payload: res.data,
//             // payload: res.data.data,
//             // totalCount: res.data.totalCount,
//          });
//       }
//    } catch (err) {
//       console.error('getPurchaseInvoices err', err);
//    }
// };

// export const getPrevAndNext = (params) => async (dispatch) => {
//    try {
//       const res = await axios.get(`/purchase-invoice/prev-next`, { params });
//       if (res.data.code === 1) {
//          dispatch({ type: GET_PURCHASE_INVOICE_PREV_AND_NEXT, payload: res.data.data });
//       }
//       return res.data.data;
//    } catch (err) {
//       console.error('getPurchaseInvoices err', err);
//    }
// };

// export const emptyPurchases = () => async (dispatch) => {
//    console.log('reset...');
//    dispatch({ type: EMPTY_ONE_PURCHASE_INVOICE, payload: null });
// };

// export const getPendingVoucherPurchasesAdjustment = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/unadjusted/pending-voucher-with-purchase-adjustments`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_PENDING_VOUCHER_PURCHASES_ADJUSTMENT,
//             payload: res.data.data,
//          });
//       }
//    } catch (error) {
//       console.error(error);
//    } finally {
//       dispatch({ type: 'SET_LOADING', payload: false });
//    }
// };

// export const getPendingPurchasesAdjustment = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/unadjusted/pending-purchase-adjustments`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_PENDING_PURCHASES_ADJUSTMENT,
//             payload: res.data.data,
//          });
//       }
//    } catch (error) {
//       console.error(error);
//    } finally {
//       dispatch({ type: 'SET_LOADING', payload: false });
//    }
// };

// export const getPendingPurchaseAdjustment = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/unadjusted/pending-purchase-adjustments`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_PURCHASE_ADJUSTMENT,
//             payload: res.data.data,
//          });
//       }
//    } catch (error) {
//       console.error(error);
//    } finally {
//       dispatch({ type: 'SET_LOADING', payload: false });
//    }
// };

// export const getPendingVoucherWithPurchaseAdjustment = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/unadjusted/pending-voucher-with-purchase-adjustments`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_PENDING_VOUCHER_WITH_PURCHASE_ADJUSTMENT,
//             payload: res.data.data,
//          });
//       }
//    } catch (error) {
//       console.error(error);
//    } finally {
//       dispatch({ type: 'SET_LOADING', payload: false });
//    }
// };

// export const getAdjustedDocs = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/purchase-invoice/adjustmentDocument`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_ADJUSTED_DOCS,
//             payload: res.data.data,
//          });
//          return res.data;
//       }
//    } catch (error) {
//       console.error(error);
//    } finally {
//       dispatch({ type: 'SET_LOADING', payload: false });
//    }
// };

// export const deleteAdjustedDocs = (id) => async (dispatch) => {
//    try {
//       if (!id) {
//          toast.warn('Please select any record', 'warning');
//          return false;
//       }
//       const res = await axios.post(`/outAdjustment/delete/${id}`);
//       if (res.data.code === 1) {
//          dispatch({ type: DELETE_ADJUSTED_DOCS, payload: { id } });
//          return res.data;
//          setTimeout(() => {
//             toast.success('Adjusted document deleted successfully!');
//          }, 1000);
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (err) {
//       if (err?.response?.data?.message) {
//          toast.error(err?.response?.data?.message);
//       }
//    }
// };

export const checkDocNo = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/purchase-order/checkDocNo', data);
      if (res.data.code === 1) {
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (error) {
      if (error?.response?.data?.message) {
         toast.error(error?.response?.data?.message);
      }
   }
};

// export const getLastPurchaseDaybooByCompanyId = (companyId) => async (dispatch, getState) => {
//    try {
//       const res = await axios.get(`/purchase-invoice/lastDaybook`, { params: { companyId } });
//       if (res.data.code === 1) {
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (error) {
//       if (error?.response?.data?.message) {
//          toast.error(error?.response?.data?.message);
//       }
//    }
// };

// export const getLastPurchaseDocNo = (params) => async (dispatch, getState) => {
//    try {
//       const res = await axios.get(`/purchase-invoice/lastDocNo`, { params: params });
//       if (res.data.code === 1) {
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (error) {
//       if (error?.response?.data?.message) {
//          toast.error(error?.response?.data?.message);
//       }
//    }
// };

// export const getItemPrice = (params) => async (dispatch) => {
//    try {
//       const res = await axios.get('/purchase-invoice/itemPrice', { params: params });
//       if (res.data.code === 1) {
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//       return res.data;
//    } catch (error) {
//       if (error?.response?.data?.message) {
//          toast.error(error?.response?.data?.message);
//       }
//    }
// };

// export const uploadPurchasesDocument = (formData) => async (dispatch) => {
//    try {
//       const res = await axios.post('/purchase-invoice/addImg', formData, {
//          headers: {
//             'Content-Type': 'multipart/form-data',
//          },
//       });
//       if (res.data.code === 1) {
//          dispatch({ type: UPDATE_PURCHASES_DOC, payload: res.data.data });
//          toast.success(res.data.message);
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          toast.warn(res.data.message);
//       }
//    } catch (err) {
//       if (err.response.data.message) {
//          toast.error(err.response.data.message);
//       }
//    }
// };

// export const deletePurchasesDocument = (formData) => async (dispatch) => {
//    try {
//       const res = await axios.post('/purchase-invoice/deleteImg', formData, {
//          headers: {
//             'Content-Type': 'multipart/form-data',
//          },
//       });
//       if (res.data.code === 1) {
//          dispatch({ type: DELETE_PURCHASES_DOC, payload: res.data.data });
//          toast.success(res.data.message);
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          toast.warn(res.data.message);
//       }
//    } catch (err) {
//       if (err.response.data.message) {
//          toast.error(err.response.data.message);
//       }
//    }
// };

export const deleteMultiPurchasesOrder = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post("/purchase-order/delete/multi", formData);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_MULTI_PURCHASES_ORDER, payload: res.data.data });
         setTimeout(() => {
            toast.success('Purchases Order deleted successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

// export const partyServiceBlock = (formData) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.post("/purchase-invoice/partyServiceBlock", formData);
//       if (res.data.code === 1) {
//          dispatch({ type: PARTY_SERVICE_BLOCK, payload: res.data.data });
//          setTimeout(() => {
//             toast.success(res?.data?.message);
//          }, 1000);
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (err) {
//       if (err.response.data?.message) {
//          toast.error(err.response?.data?.message);
//       }
//    }
// };

// export const getStorePurchases = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get("/purchase-invoice/storePurchases", { params });
//       if (res.data.code === 1) {
//          dispatch({ type: GET_STORE_PURCHASES, payload: res.data.data });
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (err) {
//       if (err.response.data?.message) {
//          toast.error(err.response?.data?.message);
//       }
//    }
// };